export default __webpack_public_path__ + "static/media/account-group.35144301.svg";